
// const APP_WINDOW_CONFIG = {
//     OFFSET_HEADER_YPOS_PX: 110,
//     SIDEBAR_WIDTH_PX: 230,
//     SIDEBAR_WIDTH_COLLAPSED_PX: 50,
//     CHAT_WIDTH_RELATIVE: 0.25,
//     MIN_CHAT_WIDTH_PX: 400,
//     OFFSET_WINDOW_RIGHT_PX: 7,
//     OFFSET_WINDOW_LEFT_PX: -4,
// }



const APP_WINDOW_CONFIG = {
    OFFSET_HEADER_YPOS_PX: 110,
    SIDEBAR_WIDTH_PX: 230,
    SIDEBAR_WIDTH_COLLAPSED_PX: 50,
    CHAT_WIDTH_RELATIVE: 0.,
    MIN_CHAT_WIDTH_PX: 0,
    OFFSET_WINDOW_RIGHT_PX: 7,
    OFFSET_WINDOW_LEFT_PX: -4,
}

export default APP_WINDOW_CONFIG

